import script from "./security-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./security-settings.vue?vue&type=script&setup=true&lang=js"

import "./security-settings.vue?vue&type=style&index=0&id=48a62268&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a62268"]])

export default __exports__